import { FrontEndWrapper } from './components/frontend-wrapper/frontend-wrapper';
import { ConfigProvider } from 'antd';
import './i18n';

const { render } = wp.element;

document.addEventListener('DOMContentLoaded', () => {
	const rootElement = document.getElementById('bookr-front-end');
	if (rootElement) {
		render(
			<ConfigProvider
				theme={{
					token: {
						colorPrimary: window.bookrPluginData.primaryColor,
					},
				}}
			>
				<FrontEndWrapper />
			</ConfigProvider>,

			document.getElementById('bookr-front-end')
		);
	}
});
